import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../../context';
import { ICSF } from '../../../globals/interfaces';
import { notify } from '../../../utils';
import ActionIcon from '../../custom/ActionIcon';

import ModalUploadCsv from './ModalUploadCsv';
import styled from 'styled-components';
import apiClient from '../../../apiClient';
import VirtualTable from '../../custom/VirtualTable';
import IcsfModal from './IcsfModal';

interface Props {
    activeTabId: string;
    type: 'icsf' | 'shippers';
}

export default function IcsfShipper ({
    activeTabId,
    type
}: Props) {

    const { user } = useAppContext();
    const [data, setData] = useState<Array<ICSF>>([]);
    const [modal, setModal] = useState(false);
    const [modalUpload, setModalUpload] = useState(false);
    const [selectedId, setSelectedId] = useState<number>();
    const selectedItem = data.find(item => item.id === selectedId);

    useEffect(() => {
        const getIacData = async () => {
            const res = await apiClient.get(`/iacCcsf/${type}`);
            if (res.status === 200) {
                setData(res.data);
            }
        }
        if (activeTabId === type && data.length === 0) {
            getIacData();
        }
    }, [activeTabId, data]);

    const manageItem = (id?: number) => {
        setSelectedId(id);
        setModal(true);
    }

    const createItem = async (data: ICSF) => {
        const res = await apiClient.post(`/iacCcsf/${type}`, data);
        if (res.status === 200) {
            notify('Created');
            setData(prev => {
                const copy = _.cloneDeep(prev);
                copy.push(res.data);
                return copy;
            });
            setModal(false);
        }
    }

    const updateItem = async (data: ICSF) => {
        const res = await apiClient.put(`/iacCcsf/${type}`, data);
        if (res.status === 200) {
            notify('Updated');
            setData(prev => {
                const copy = _.cloneDeep(prev);
                const updateIndex = copy.findIndex(item => item.id === data.id);
                copy[updateIndex] = res.data;
                return copy;
            });
            setModal(false);
        }
    }

    const handleCreateUpdate = (update: boolean, data: ICSF) => {
        const fn = update ? updateItem : createItem;
        fn(data);
    }

    const deleteItem = async (id: number) => {
        const res = await apiClient.delete(`/iacCcsf/${type}/${id}`);
        if (res.status === 204) {
            notify('Deleted');
            setData(prev => {
                const filtered = prev.filter(item => item.id !== id);
                return filtered;
            });
            setModal(false);
        }
    }

    const uploadCsv = async (data: Array<any>) => {
        try {
            const res = await apiClient.post(`/iacCcsf/${type}-upload`, data);
            const { message, newData } = res.data;
            setModalUpload(false);
            notify(message);
            setData(newData);
        } catch (err) {
            notify(err, 'error');
        }
    }

    return (
        <div>
            <FlexContainer>
                <ActionIcon
                    type={'add'}
                    onClick={manageItem}
                />
                <ActionIcon
                    type={'upload'}
                    onClick={() => setModalUpload(true)}
                />
            </FlexContainer>
            <VirtualTable
                data={data}
                mapping={[{
                    name: 'Approval Number',
                    value: 'approval_number'
                }, {
                    name: 'Certified Cargo Screening Facility',
                    value: 'certified_cargo_screening_facility_name'
                }, {
                    name: 'Street',
                    value: 'street_address'
                }, {
                    name: 'City',
                    value: 'city'
                }, {
                    name: 'State',
                    value: 'state',
                    customWidth: 50
                }, {
                    name: 'Expiration',
                    value: 'ccsf_expiration_date',
                    date: true,
                    utc: true,
                    sortMethod: (a: string, b: string) => +new Date(a) - +new Date(b)
                }, {
                    name: 'Valid',
                    value: 'valid',
                    boolean: true,
                    customWidth: 50
                }]}
                index
                enableClick
                handleClick={item => manageItem(item.id)}
            />
            <IcsfModal
                modal={modal}
                setModal={setModal}
                selectedItem={selectedItem}
                handleCreateUpdate={handleCreateUpdate}
                deleteItem={deleteItem}
                user={user}
            />
            <ModalUploadCsv
                modal={modalUpload}
                setModal={setModalUpload}
                type={type}
                submit={uploadCsv}
            />
        </div>
    );
}

export const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;